import { useState } from 'react';
import { useFriends } from '../hooks/useFriends';

// MUI components
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  Alert,
  Snackbar,
  CircularProgress
} from '@mui/material';
import { PersonAdd as PersonAddIcon } from '@mui/icons-material';

const AddFriend = () => {
  const { sendFriendRequest } = useFriends();
  
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email.trim()) {
      setError('Please enter an email address');
      return;
    }
    
    try {
      setLoading(true);
      setError('');
      
      await sendFriendRequest(email.trim());
      
      // Show success message and clear form
      setSuccess(true);
      setEmail('');
      setLoading(false);
    } catch (err) {
      setError('Failed to send friend request: ' + err.message);
      setLoading(false);
    }
  };
  
  return (
    <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
      <Typography variant="h6" gutterBottom>
        Add a Friend
      </Typography>
      
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      
      <Box component="form" onSubmit={handleSubmit}>
        <TextField
          fullWidth
          label="Friend's Email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter your friend's email"
          margin="normal"
          required
        />
        
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={loading}
          startIcon={loading ? <CircularProgress size={20} /> : <PersonAddIcon />}
          sx={{ mt: 2 }}
        >
          {loading ? 'Sending...' : 'Send Friend Request'}
        </Button>
      </Box>
      
      <Snackbar
        open={success}
        autoHideDuration={6000}
        onClose={() => setSuccess(false)}
        message="Friend request sent successfully!"
      />
    </Paper>
  );
};

export default AddFriend; 